const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const KEY = "cm_attribution";
const INITIAL_SEARCH = typeof window !== "undefined" ? window.location.search : "";

const refSource = (ref) => {
  try {
    const h = new URL(ref).hostname;
    if (h.includes("youtube") || h.includes("youtu.be")) return "youtube";
    if (h.includes("google")) return "google";
    if (h.includes("facebook") || h.includes("fb.")) return "facebook";
    if (h.includes("instagram")) return "instagram";
    if (h.includes("tiktok")) return "tiktok";
    if (h.includes("whatsapp") || h.includes("wa.me")) return "whatsapp";
    return h;
  } catch {
    return null;
  }
};

export function captureAttribution() {
  try {
    const params = new URLSearchParams(INITIAL_SEARCH || window.location.search);
    const ref = document.referrer || "";
    const sameSite = ref && ref.includes(window.location.hostname);
    const data = {
      source: params.get("utm_source") || (!sameSite ? refSource(ref) : null),
      medium: params.get("utm_medium") || null,
      campaign: params.get("utm_campaign") || null,
      referrer: !sameSite ? ref : null,
      path: window.location.pathname,
      ad_country: (params.get("country") || "").toUpperCase().slice(0, 2) || null,
    };
    if (data.source && !localStorage.getItem(KEY)) {
      localStorage.setItem(KEY, JSON.stringify(data));
    }
    const lastSent = sessionStorage.getItem("cm_visit_sent");
    const marker = data.source ? `src:${data.source}:${data.campaign || ""}` : "1";
    if (lastSent !== marker && (!lastSent || data.source)) {
      sessionStorage.setItem("cm_visit_sent", marker);
      fetch(`${BACKEND_URL}/api/track/visit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).catch(() => {});
    }
  } catch {}
}

export function sendUserAttribution() {
  try {
    const stored = localStorage.getItem(KEY);
    if (!stored || localStorage.getItem(`${KEY}_sent`)) return;
    const headers = { "Content-Type": "application/json" };
    const token = localStorage.getItem("session_token");
    if (token) headers["Authorization"] = `Bearer ${token}`;
    fetch(`${BACKEND_URL}/api/track/attribution`, {
      method: "POST",
      credentials: "include",
      headers,
      body: stored,
    })
      .then((r) => {
        if (r.ok) localStorage.setItem(`${KEY}_sent`, "1");
      })
      .catch(() => {});
  } catch {}
}
